<template>
  <div class="onboarding-shell">
    <!--
      Sin <transition mode="out-in">: en pruebas reales el DOM se quedó
      congelado en el paso anterior mientras `step` ya había avanzado
      internamente, porque Vue espera el evento `transitionend` del CSS
      antes de montar la siguiente pantalla y ese evento no siempre llega
      de forma confiable. Preferimos un cambio instantáneo y confiable
      sobre un fade que puede colgar la UI.
    -->
    <PantallaBienvenida v-if="step === 'bienvenida'" key="bienvenida" @comenzar="step = 'datos'" />

    <PantallaDatos
      v-else-if="step === 'datos'"
      key="datos"
      :loading="loading"
      :error-msg="errorMsg"
      @enviar="enviarDatos"
    />

    <PantallaOtp
      v-else-if="step === 'otp'"
      key="otp"
      :loading="loading"
      :error-msg="errorMsg"
      :whatsapp-mostrado="`${lada} ${whatsapp}`"
      @verificar="verificarOtp"
      @reenviar="reenviarOtp"
    />

    <PantallaConfirmacion v-else-if="step === 'confirmacion'" key="confirmacion" />

    <PantallaPerfilamiento
      v-else-if="step === 'perfilamiento'"
      key="perfilamiento"
      :nombre="nombre"
      :loading="loading"
      :error-msg="errorMsg"
      @guardar="guardarPreferencias"
    />

    <PantallaResultado
      v-else-if="step === 'resultado'"
      key="resultado"
      @nuevo-sueno="crearNuevoSueno"
      @conocer-catalogo="conocerCatalogo"
    />
  </div>
</template>

<script>
import axios from 'axios';
import PantallaBienvenida from './PantallaBienvenida.vue';
import PantallaDatos from './PantallaDatos.vue';
import PantallaOtp from './PantallaOtp.vue';
import PantallaConfirmacion from './PantallaConfirmacion.vue';
import PantallaPerfilamiento from './PantallaPerfilamiento.vue';
import PantallaResultado from './PantallaResultado.vue';

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
axios.defaults.headers.common['Accept'] = 'application/json';

export default {
  name: 'OnboardingApp',
  components: {
    PantallaBienvenida,
    PantallaDatos,
    PantallaOtp,
    PantallaConfirmacion,
    PantallaPerfilamiento,
    PantallaResultado,
  },
  props: {
    initialStep: { type: String, default: 'bienvenida' },
    initialNombre: { type: String, default: '' },
    catalogoUrl: { type: String, default: '/propiedades' },
  },
  data() {
    return {
      step: this.initialStep,
      nombre: this.initialNombre,
      lada: '+52',
      whatsapp: '',
      loading: false,
      errorMsg: '',
      onboardingCompleted: false,
    };
  },
  methods: {
    async enviarDatos({ nombre, lada, whatsapp }) {
      this.loading = true;
      this.errorMsg = '';

      try {
        await axios.post('/onboarding/solicitar-otp', { nombre, lada, whatsapp });
        this.nombre = nombre;
        this.lada = lada;
        this.whatsapp = whatsapp;
        this.step = 'otp';
      } catch (e) {
        this.errorMsg = this.extraerError(e, 'No pudimos enviar el código. Intenta de nuevo.');
      } finally {
        this.loading = false;
      }
    },

    async reenviarOtp() {
      await this.enviarDatos({ nombre: this.nombre, lada: this.lada, whatsapp: this.whatsapp });
    },

    async verificarOtp(codigo) {
      this.loading = true;
      this.errorMsg = '';

      try {
        const { data } = await axios.post('/onboarding/verificar-otp', {
          whatsapp: this.whatsapp,
          code: codigo,
        });

        this.onboardingCompleted = !!data.onboarding_completed;
        this.step = 'confirmacion';

        setTimeout(() => {
          this.step = this.onboardingCompleted ? 'resultado' : 'perfilamiento';
        }, 1800);
      } catch (e) {
        this.errorMsg = this.extraerError(e, 'Código incorrecto.');
        throw e; // deja que PantallaOtp limpie los recuadros
      } finally {
        this.loading = false;
      }
    },

    async guardarPreferencias(preferencias) {
      this.loading = true;
      this.errorMsg = '';

      try {
        await axios.post('/onboarding/preferencias', preferencias);
        this.step = 'resultado';
      } catch (e) {
        this.errorMsg = this.extraerError(e, 'No pudimos guardar tus preferencias.');
      } finally {
        this.loading = false;
      }
    },

    crearNuevoSueno() {
      this.step = 'perfilamiento';
    },

    conocerCatalogo() {
      window.location.href = this.catalogoUrl;
    },

    extraerError(e, fallback) {
      const data = e && e.response && e.response.data;
      if (!data) return fallback;
      if (data.errors) return Object.values(data.errors).flat().join(' ');
      if (data.message) return data.message;
      return fallback;
    },
  },
};
</script>
